import React from "react";
import useWebsiteConfiguration from "../../../hooks/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../enums/websiteConfigurations/websiteConfigurationType.enum";
import HeaderLogoComponent from "../header/HeaderLogoComponent";

const FooterAboutUsComponent = () => {
  const { Title, Text } = useWebsiteConfiguration(websiteConfigurationEnum.HomeAboutUs);

  return (
    <div className="footerSection aboutUsSection">
      <HeaderLogoComponent />
    </div>
  );
};

export default FooterAboutUsComponent;
